import { useI18n } from 'hooks/useI18n';
import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { StyledRecharts } from './Recharts.styled';

const TimeToHireSeniority: React.FC = () => {
  const { t } = useI18n('state-of-hiring');

  const GRAPH_03_TIME_TO_HIRE_BY_SENIORITY = [
    { label: 'Senior', value: 48, fill: '#147092' },
    { label: 'Mid-Level', value: 43, fill: '#147092' },
    { label: 'Junior', value: 43, fill: '#147092' }
  ];

  return (
    <div>
      <StyledRecharts>
        <ResponsiveContainer width="99%" height={132}>
          <BarChart data={GRAPH_03_TIME_TO_HIRE_BY_SENIORITY} layout="vertical">
            <XAxis
              type="number"
              allowDecimals={false}
              tickLine={false}
              padding={{ left: 10 }}
            />
            <YAxis
              type="category"
              dataKey="label"
              tickLine={false}
              width={70}
            />
            <Tooltip
              cursor={{ fill: '#dffffd' }}
              labelStyle={{ display: 'none' }}
              separator=""
              formatter={(value: number) => [
                value + ' ' + t('state-of-hiring.time-to-hire.days'),
                ''
              ]}
              wrapperClassName="tooltip-y"
            />
            <Bar dataKey="value" fill="#147092" barSize={12} radius={6} />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
    </div>
  );
};

export default TimeToHireSeniority;
